import { createInvalidStateError } from '../factories/invalid-state-error';
export const createGetNativeContext = (contextStore) => {
    return (context) => {
        const nativeContext = contextStore.get(context);
        if (nativeContext === undefined) {
            throw createInvalidStateError();
        }
        return nativeContext;
    };
};
//# sourceMappingURL=/build/es2018/factories/get-native-context.js.map